// extracted by mini-css-extract-plugin
export var parcelRow = "_uw-0";